import { useState } from "react";

import MenuCategories from "./MenuCategories";

import { Drawer } from "@/components";
import styles from "@/styles/containers/menu.module.scss";
import { Builder } from "@olga-food/schemas/lib/classes/schemas/catalog/Builder";
import ProductDetails from "../Product/ProductDetails";
import Products from "../Product/Products";

export default function Menu({ catalog, onBack, onOpenCart }) {
  const [selectedCategory, setSelectedCategory] = useState(catalog.items[0]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [openProductDetails, setOpenProductDetails] = useState(false);
  const [cartItemIndex, setCartItemIndex] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const deepCopy = (data) => {
    if (!data) {
      return data;
    }

    return JSON.parse(JSON.stringify(data));
  };

  const getGroupedCategories = () => {
    const availableCategories = catalog.items.filter((item) => {
      return (
        item.show &&
        item.available &&
        item.visible &&
        item.showAll !== false &&
        item.showTablet !== false
      );
    });

    const groupedCategories = availableCategories.reduce((acc, item) => {
  
      const groupKey = item.group_id ?? "Outros produtos";
  
      if (!acc[groupKey]) acc[groupKey] = [];
  
      acc[groupKey].push(item);
  
      return acc;
    }, {});

    return groupedCategories;
  }

  const groupedCategories = getGroupedCategories();

  const mountPizza = (category, product) => {
    let localSelectedProduct = product;

    const firstSize = product.sizes[0];
    const officialProductSizes = product.sizes.map((s) => s.ref_id);

    const pizzaProduct = Builder.factory("Pizza");
    pizzaProduct.id = product.id;
    pizzaProduct.name = product.name;
    pizzaProduct.max_flavors = firstSize.max;
    pizzaProduct.highlight = product.highlight;
    pizzaProduct.sizes = product.sizes.map((size) => {
      return {
        ...size,
        selected: size.ref_id === firstSize.ref_id,
      };
    });

    pizzaProduct.doughs = category.doughs.filter((dough) => {
      dough.quantity = 0;
      return (
        dough.sizes.filter((s) => officialProductSizes.indexOf(s.ref_id) > -1)
          .length > 0
      );
    });

    pizzaProduct.edges = category.edges.filter((edge) => {
      edge.quantity = 0;
      return (
        edge.sizes.filter((s) => officialProductSizes.indexOf(s.ref_id) > -1)
          .length > 0
      );
    });

    pizzaProduct.items = category.items.filter((item) => {
      item.quantity = 0;

      if (product.type == "flavor" && product.ref_id == item.ref_id) {
        item.quantity = 1;
      }

      return (
        item.sizes.filter((s) => officialProductSizes.indexOf(s.ref_id) > -1)
          .length > 0
      );
    });

    pizzaProduct.extra_ingredients = category.extra_ingredients.filter(
      (extra) => {
        return (
          extra.sizes.filter((size) =>
            officialProductSizes.includes(size.ref_id)
          ).length > 0
        );
      }
    );

    localSelectedProduct = Builder.mountSchema(
      JSON.parse(JSON.stringify(pizzaProduct))
    );

    localSelectedProduct.quantity = localSelectedProduct.quantity || 1;

    localSelectedProduct.image = product.image;
    localSelectedProduct.description = product.description;

    return localSelectedProduct;
  };

  const onSelectProduct = (product) => {
    let category = null;
    for (const item of catalog.items) {
      if (item.id == product.parent) {
        category = item;

        if (item.type != "flavor") {
          product.extra_ingredients = deepCopy([...item.extra_ingredients]);
        }

        break;
      }
    }

    if (product.type === "flavor") {
      const mountedPizza = mountPizza(deepCopy(category), deepCopy(product));
      setSelectedProduct({
        category: deepCopy(category),
        product: mountedPizza,
      });
    } else {
      setSelectedProduct(
        deepCopy({
          category,
          product,
        })
      );
    }

    setOpenProductDetails(true);
    setSelectedProduct(JSON.parse(JSON.stringify(product)));
    setCartItemIndex(null);
  };

  return (
    <div className={styles.menuContainer}>
      <MenuCategories
        categories={groupedCategories}
        onSelectCategory={(category) => setSelectedCategory(category)}
        onBack={onBack}
        searchTerm={searchTerm}
      />

      <Products
        categories={groupedCategories}
        category={selectedCategory}
        onSelectProduct={(product) => onSelectProduct(product)}
        onOpenCart={onOpenCart}
        onSearch={(term) => setSearchTerm(term)}
      />

      <Drawer
        open={openProductDetails}
        direction="center-full"
        onClose={() => setOpenProductDetails(false)}
        withoutPadding
      >
        <ProductDetails
          cartItemIndex={cartItemIndex}
          product={selectedProduct}
          onClose={() => setOpenProductDetails(false)}
        />
      </Drawer>
    </div>
  );
}
